// eslint-disable-next-line no-restricted-imports
import {
  CreateOperationDto_Input,
  MutationInput_OperationController_CreateOne_Input_ExecutionMethod,
  Trade_Const,
} from 'api/generated/graphql';
import { OperationType } from 'api/types/entity/operation';
import { CreateAndUpdateOperationParams } from 'api/types/params';
import { formatToISODate, formatToISODateTime } from 'helpers';

export const parseCreateOperationParams = (
  params: CreateAndUpdateOperationParams
): CreateOperationDto_Input => ({
  type: Trade_Const[OperationType.Trade],
  orderId: params.orderId,
  number: params.number,
  executedAt: formatToISODateTime(params.executedAt),
  executionPlaceDirectoryRecordId: params.executionPlaceDirectoryRecordId,
  executionMethod:
    MutationInput_OperationController_CreateOne_Input_ExecutionMethod[
      params.executionMethod
    ],
  isSpecializedTrade: params.isSpecializedTrade,
  traderId: params.traderId,
  counterpartyName: params.counterpartyName || null,
  quantity: params.quantity,
  netUnitPrice: params.netUnitPrice,
  unitPrice: params.unitPrice,
  accruedCouponIncome: params.accruedCouponIncome,
  volume: params.volume,
  settlementDate: formatToISODate(params.settlementDate),
  exchangeRate: params.exchangeRate,
  confirmationFileIds: params.confirmationFileIds.length
    ? params.confirmationFileIds
    : undefined,
  additionalNotes: params.additionalNotes,
});
